import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  Alert,
  CircularProgress,
} from "@mui/material";

export const PreviewDialog = ({
  isOpen,
  onClose,
  previewData,
  onConfirm,
  isUploading
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        Prévia das Alterações
      </DialogTitle>
      <DialogContent>
        {previewData && (
          <Box>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Total de unidades no arquivo: {previewData.total}
            </Typography>

            {previewData.toCreate.length > 0 && (
              <>
                <Typography variant="h6" color="success.main" sx={{ mb: 1 }}>
                  Unidades a serem criadas ({previewData.toCreate.length}):
                </Typography>
                <List dense>
                  {previewData.toCreate.map((name, index) => (
                    <ListItem key={index}>
                      <ListItemText primary={name} />
                    </ListItem>
                  ))}
                </List>
                <Divider sx={{ my: 2 }} />
              </>
            )}

            {previewData.toDeactivate.length > 0 && (
              <>
                <Typography variant="h6" color="warning.main" sx={{ mb: 1 }}>
                  Unidades a serem desativadas ({previewData.toDeactivate.length}):
                </Typography>
                <List dense>
                  {previewData.toDeactivate.map((name, index) => (
                    <ListItem key={index}>
                      <ListItemText primary={name} />
                    </ListItem>
                  ))}
                </List>
              </>
            )}

            {previewData.toCreate.length === 0 &&
              previewData.toDeactivate.length === 0 && (
                <Alert severity="info">
                  Nenhuma alteração será realizada.
                </Alert>
              )}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          disabled={isUploading}
          startIcon={isUploading ? <CircularProgress size={20} /> : null}
        >
          {isUploading ? "Atualizando..." : "Confirmar Atualização"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
